import { useGetAiAgentsSettingService } from '@/context/services/ai_agents_setting/AiAgentsSetting.service';
import { useMemo } from 'react';

export const useGetAiAgentsSetting = () => {
  const { data } = useGetAiAgentsSettingService();
  const { is_ai_agent_enabled, ai_agent_service_settings = [] } = data || {};
  const mappedAiAgentServiceSettings = useMemo(() => {
    return ai_agent_service_settings.reduce((acc, service) => {
      return {
        ...acc,
        [service.service_type]: service.is_enabled,
      };
    }, {});
  }, [ai_agent_service_settings]);
  return {
    isAiAgentEnabled: is_ai_agent_enabled,
    mappedAiAgentServiceSettings,
  };
};
